export enum EnumTipoDocumentoFiscal {
  Fisica = 1,
  Juridica
}
